import Vue from 'vue'
// import store from 'vuex'

const API_AUTH_LOGOUT = '/auth/token/revoke'

export default () => {
  Vue.http.post(API_AUTH_LOGOUT)
}



// WEBPACK FOOTER //
// ./src/api/auth/logout.js